import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { FormControl } from '../ui/form'
import { Button } from '../ui/button'
import { CalendarIcon, CircleX } from 'lucide-react'
import Constant from '@/utils/Constant'
import { format } from 'date-fns'
import { Calendar } from '../ui/calendar'
import { useState } from 'react'
import { cn } from '@/lib/utils'
import { current } from '@reduxjs/toolkit'

const DatePicker = ({
    date,
    handleChange,
    className = '',
    setDate,
    selected,
    disabled = false,
    defaultMonth,
    mode = 'single',
    placeHolder,
    type = '',
}) => {
    const [calendarOpen, setCalendarOpen] = useState(false)
    console.log('type', type)
    const handleDaterangeChange = (currentDate) => {
        console.log('e', currentDate)
        if (mode == 'range' && date.from && date.to) {
            if (date.from == currentDate.from && date.to !== currentDate.to) {
                handleChange({
                    from: currentDate.to,
                    to: '',
                })
            }

            if (currentDate.from !== date.from && currentDate.to == date.to) {
                handleChange({
                    from: currentDate.from,
                    to: '',
                })
            }

            console.log('here ')
        } else {
            if (!date.to && currentDate.to) {
                setCalendarOpen(false)
            }
            handleChange(currentDate)
        }
    }
    return (
        <Popover open={calendarOpen} onOpenChange={setCalendarOpen}>
            <PopoverTrigger asChild disabled={disabled}>
                {mode == 'range' ? (
                    <Button
                        variant={'outline'}
                        onClick={() => setCalendarOpen(true)}
                        className={cn('text-left font-normal flex justify-between', !date && 'text-muted-foreground', className)}
                    >
                        <div className="flex items-center gap-2">
                            {date?.from ? (
                                <>
                                    {date.to ? (
                                        <>
                                            {format(date.from, Constant.DATE_FORMAT)} to {format(date.to, Constant.DATE_FORMAT)}
                                        </>
                                    ) : (
                                        format(date.from, Constant.DATE_FORMAT)
                                    )}
                                </>
                            ) : (
                                <span className=" text-gray-300">{placeHolder}</span>
                            )}
                        </div>
                        {date?.from !== '' && date?.to !== '' && (
                            <span
                                className="p-2"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleChange({})
                                }}
                            >
                                <CircleX />
                            </span>
                        )}
                    </Button>
                ) : (
                    <Button variant={'outline'} disabled={disabled} className={`w-full pl-3 text-left font-normal ${className}`}>
                        {date ? (date == '0000-00-00' ? '' : format(date, Constant.DATE_FORMAT)) : ''}
                        {type !== 'oasis' && <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />}
                    </Button>
                )}
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0 z-[9999]" align="start">
                {mode == 'single' ? (
                    <Calendar
                        mode={mode}
                        type={type}
                        selected={date == '0000-00-00' ? '' : date}
                        defaultMonth={date == '0000-00-00' ? '' : date}
                        onSelect={(e) => {
                            setCalendarOpen(false)
                            if (e === undefined) {
                                return
                            }
                            handleChange(e)
                        }}
                        initialFocus
                    />
                ) : (
                    <Calendar
                        mode={mode}
                        selected={selected}
                        defaultMonth={defaultMonth}
                        onSelect={(e) => {
                            if (e === undefined) {
                                return
                            }
                            handleDaterangeChange(e)
                        }}
                        initialFocus
                    />
                )}
            </PopoverContent>
        </Popover>
    )
}

export default DatePicker
